import React from 'react';
import pattern3 from '../assets/images/background/pattern-3.png'; 
import { FaWhatsapp } from "react-icons/fa";


const PreBusiness = ({ }) => {
    return (
      <div>
{/* <!-- Call To Action Section --> */}
	{/* <!-- Preparing For Your Business --> */}
	<section className="call-to-action-section" style={{ backgroundImage: `url(${pattern3})` }}>
		<div className="auto-container">
			<div className="row clearfix">
				{/* <!-- Heading Column --> */}
				<div className="heading-column col-lg-8 col-md-12 col-sm-12">
					<div className="inner-column">
						<h2>Grow Your Business  <br/> With Clear and Steady IT Support</h2>
					</div>
				</div>
				{/* <!-- Button Column --> */}
				<div className="button-column col-lg-4 col-md-12 col-sm-12">
					<div className="inner-column">
						{/* <a href="/contact" className="theme-btn btn-style-two"><span className="txt">Meet With Us</span></a> */}
						<a
							href="https://wa.me/919978623133"
							target="_blank"
							rel="noopener noreferrer"
							className="theme-btn btn-style-two whatsapp-btn">
							{/* <FaWhatsapp style={{ marginRight: "8px" }} /> */}
							<span className="txt">Meet With Us</span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>
	{/* <!-- End Call To Action Section --> */}
</div>
  );
};

export default PreBusiness;
